import { render, staticRenderFns } from "./EditSourceForm.vue?vue&type=template&id=fdeaad0e&"
import script from "./EditSourceForm.vue?vue&type=script&lang=ts&"
export * from "./EditSourceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports